<template>
  <div id="app">
    <Logo @clicked="closeMenu"></Logo>
    <Menu ref="menu"></Menu>
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Logo from '@/components/Logo'

export default {
  name: 'App',
  components: {
    Logo, Menu
  },
  methods: {
    closeMenu () {
      this.$refs.menu.close()
    }
  }
}
</script>

<style lang="scss">

@import './scss/fonts';

*, *:before, *:after {
  box-sizing: border-box;
}

html, body, #app {
  height: 100%;
  font-size: 18px;
  line-height: 1.44em;
}



.fade-enter-active {
  transition: opacity 600ms ease, transform 600ms ease;
}

.fade-leave-active {
  transition: opacity 600ms ease, transform 600ms ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: scale(1) translateY(7px);
}

#app {
  // font-family: 'Formular', Helvetica, Arial, sans-serif;
  font-family: 'Proto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #000;
}

p {
  letter-spacing: -0.2px;
  margin: 0;
}

p + p {
  margin-top: 1.2em;
}

a {
  text-decoration: none;
  color: inherit;
}

p a {
  border-bottom: 1px solid #d8d8d8;
}

</style>



// WEBPACK FOOTER //
// src/App.vue